import { Component, OnInit, inject, ViewChild, ElementRef } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SystemApp } from '../../constans/SystemConfigurations';
import { ApiUrl } from '../../shared/models/apiurl.models';
import {ContactMenuComponent} from "../contact-menu/contact-menu.component";
import {Router} from "@angular/router";
import { DragScrollDirective } from '../../shared/directives/drag-scroll.directive';
import { CardBizBadgesComponent, CardDealerComponent } from '../card-seller/card-seller.component';

interface CarColor {
  id: number;
  colorName: string;
  colorCode: string;
}

interface CarCity {
  id: number;
  nameHe: string;
  nameEng: string;
}

interface CarOwner {
  id: number;
  Type: string;
}

interface NumberOfOwner {
  id: number;
  numberOnwer: string;
  weight: number;
}

interface CarImage {
  image: string;
  SortNum: number | null;
}

interface Armature {
  id: number;
  ArmatureDesc: string;
  ArmatureIcon: string;
}

interface AdsRoute {
  id: number;
  title: string;
  level: string;
}

interface UserContact {
  id: number;
  contactPerson: string;
  phoneNumber: string;
  email: string;
}

interface SconderyCategory {
  id: number;
  name: string;
  subCategory: string;
}

interface Car {
  id: number;
  name: string;
  CodeProducer: string;
  MainModel: string | null;
  year: number;
  mileage: number | null;
  engineCapacity: number | null;
  gearBox: string | null;
  price: number | null;
  description: string;
  FreeText: string | null;
  Color: CarColor;
  city: CarCity | null;
  CurrentOwner: CarOwner;
  PastOwner: CarOwner | null;
  NumberOfOwner: NumberOfOwner;
  images: CarImage[];
  armatureList: Armature[];
  adsRoute: AdsRoute;
  userContactDetails: UserContact;
  sconderyCategory: SconderyCategory;
  DrivingTest: boolean | null;
  DisabledSuitable: boolean | null;
  exchange: boolean | null;
  video_url: string | null;
  statusAds: string;
  /** Present on every product; used to detect internal (admin) ads merged into this listing. */
  resourcetype?: string;
}

interface CarResponse {
  page_size: number;
  object_list: Car[];
}

@Component({
    selector: 'app-car-listings',
    imports: [ContactMenuComponent, DragScrollDirective, CardBizBadgesComponent, CardDealerComponent],
    templateUrl: 'car-bar.component.html',
    styleUrls: ['car-bar.component.scss']
})
export class CarListingsComponent implements OnInit {
  private http = inject(HttpClient);
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  };

  cars: Car[] = [];
  isLoading = false;
  error: string | null = null;

  @ViewChild('carTrack') carTrack!: ElementRef<HTMLElement>;

  private apiUrl = SystemApp.base_url_api + '/clientAjax/productVFilteriewSet';

  constructor(private apiKey: ApiUrl, private route:Router) {}

  ngOnInit(): void {
    this.loadCars();
  }

  loadCars(): void {
    this.isLoading = true;
    this.error = null;

    this.http
        .post<CarResponse>(
            `${this.apiUrl}?limit=36&offset=1&model_class=car`,
            {},
            { headers: this.options.headers }
        )
        .pipe(
            catchError((err) => {
              this.error = err.message;
              this.isLoading = false;
              return of(null);
            })
        )
        .subscribe((res) => {
          if (res) {
            this.cars = res.object_list;
          }
          this.isLoading = false;
        });
  }

  scrollLeft(): void {
    this.carTrack.nativeElement.scrollBy({ left: -360, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.carTrack.nativeElement.scrollBy({ left: 360, behavior: 'smooth' });
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src =
        'https://placehold.co/400x260/e8e4df/8a8580?text=🚗';
  }

  formatMileage(mileage: number | null): string {
    if (!mileage) return '—';
    if (mileage >= 1000000) return (mileage / 1000).toLocaleString() + ' ק״מ';
    return mileage.toLocaleString() + ' ק״מ';
  }

  formatPrice(price: number | null): string {
    if (!price) return 'ליצירת קשר';
    return '₪' + price.toLocaleString();
  }

  getAdsBadge(level: string): string {
    switch (level) {
      case 'LEVEL3': return '⭐ VIP';
      case 'LEVEL2': return '🔥 מודגשת';
      default: return '';
    }
  }

  isPromoted(car: Car): boolean {
    return car.adsRoute.level !== 'LEVEL1';
  }

  /**
   * Internal (admin) ads linked to this category are merged into the same
   * listing by the backend (clinetApi.views.ProductVFilteriewSet.get_queryset).
   * They only carry the generic Product fields (name/price/images/description/
   * city), none of the car-specific ones — so they need a simpler card.
   */
  isInternalAd(car: Car): boolean {
    return (car.resourcetype || '').toLowerCase() === 'internalads';
  }
  openPage(id:any){
    this.route.navigate([`single/${id}`])
  }

  navigateToPage() {
    this.route.navigate([`shop/car`])
  }
}